import type { CurationStatus } from '../api/reviewsApi';
import { STATUS_LABEL, STATUS_TONE } from '../status';

/** Pill badge for a review/testimonial's curation status. Follows the DisputeStatusBadge pattern. */
export function CurationStatusBadge({ status }: { status: CurationStatus }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
        STATUS_TONE[status] ?? 'bg-muted text-muted-foreground'
      }`}
    >
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}
